import { Location, locationName } from '@cobliteam/common-types';

import { lazy } from '@cobliteam/lazy-with-retries';

const GeofencesRouter = lazy(() => import('../pages/index'));
const GeofencesPage = lazy(() => import('../pages/GeofencesPage'));
const GeofencesPageNew = lazy(() => import('../pages/GeofencesPageNew'));

const routes = [
  {
    title: locationName[Location.GEOFENCES],
    path: Location.GEOFENCES,
    component: GeofencesRouter,
    needsGoogleMaps: true,
    routes: [
      {
        title: locationName[Location.GEOFENCES],
        path: Location.GEOFENCES,
        component: GeofencesPage,
        exact: true,
      },
      {
        title: locationName[Location.GEOFENCES_CREATE],
        path: Location.GEOFENCES_CREATE,
        component: GeofencesPageNew,
        exact: true,
      },
      {
        title: locationName[Location.GEOFENCES_EDIT],
        path: Location.GEOFENCES_EDIT,
        component: GeofencesPageNew,
        exact: true,
      },
    ],
  },
];

export default routes;
